import api from "@/services/http/api";
import apiAuth from "@/services/http/apiAuth";

/* ============================================================
   PÚBLICAS
   ============================================================ */

/**
 * Lista de eventos publicados.
 */
export async function listarEventos({ from = null, to = null, status = "published" } = {}) {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  if (status) params.status = status;
  const res = await api.get("/appointments", { params });
  return res.data;
}

export async function obtenerEvento(id) {
  const res = await api.get(`/appointments/${id}`);
  return res.data;
}

/* ============================================================
   ADMIN
   ============================================================ */

export async function listarEventosAdmin() {
  const res = await apiAuth.get("/appointments/admin/all");
  return res.data;
}

export async function listarContactosEventos() {
  const res = await apiAuth.get("/appointments/admin/contacts");
  return res.data;
}

export async function crearEvento(payload) {
  const res = await apiAuth.post("/appointments", payload);
  return res.data;
}

export async function editarEvento(id, payload) {
  const res = await apiAuth.put(`/appointments/${id}`, payload);
  return res.data;
}

export async function eliminarEvento(id) {
  const res = await apiAuth.delete(`/appointments/${id}`);
  return res.data;
}

/* ============================================================
   REGLAMENTO (PDF)
   ============================================================ */

export async function subirReglamento(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiAuth.post(`/appointments/${id}/reglamento`, formData);
  return res.data;
}

export async function eliminarReglamento(id) {
  const res = await apiAuth.delete(`/appointments/${id}/reglamento`);
  return res.data;
}
